module.exports = __webpack_public_path__ + "img/device_point6-1_m.721ccf36.png";